import hasDraftAndPublish from './has-draft-and-publish';
import hasPermissions from './hasPermissions';

export default {
  'has-draft-and-publish': hasDraftAndPublish,
  hasPermissions,
};
